import { EmbeddedBOQCoatProduct } from '../interfaces';

const sqftToSqm = 0.092903;
const gallonToLitre = 3.78541;
const spreadRateConversion = sqftToSqm / gallonToLitre;

export const isSpreadRateCustom = (cp: EmbeddedBOQCoatProduct)  => {
	const method = findMethod(cp);
	if (method) {
		const defSpreadRate = method.spreadRate;
		return typeof cp.spreadRate === 'number'
			&& typeof defSpreadRate === 'number'
			&& !equal(Number(cp.spreadRate.toFixed(2)), Number(defSpreadRate.toFixed(2)));
	}

}

export const isApplicationRateCustom = (cp: EmbeddedBOQCoatProduct, boqHeightRange?: string) => {
	const method = findMethod(cp);
	if (method) {
		let defApplicationRate = method.applicationTargetRate;

		if (boqHeightRange) {
			for (let heightRangeRate of method.heightRangeRates) {
				if (heightRangeRate.title === boqHeightRange) {
					defApplicationRate = heightRangeRate.value;
				}
			}
		}

		return typeof cp.targetRate === 'number'
			&& typeof defApplicationRate === 'number'
			&& !equal(Number(cp.targetRate.toFixed(2)), Number(defApplicationRate.toFixed(2)));
	}
}

const findMethod = (cp: EmbeddedBOQCoatProduct) => {
	const methods = cp?.product?.applicationMethods ?? [];
	const wanted = (cp.applicationMethod ?? '').trim().toLowerCase();
	return methods.find(m => (m.type ?? '').trim().toLowerCase() === wanted);
}

export const defaultSpread = (cp: EmbeddedBOQCoatProduct, imperial: boolean) => {
	const method = findMethod(cp);
	return imperial
		? (method?.spreadRate / spreadRateConversion).toFixed(2)
		: method?.spreadRate;
}

export const defaultApp = (cp: EmbeddedBOQCoatProduct,  imperial: boolean, boqHeightRange?: string) => {
	const method = findMethod(cp);
	if (boqHeightRange) {
		for (let heightRangeRate of method.heightRangeRates) {
			if (heightRangeRate.title === boqHeightRange) {
				return imperial
					? (heightRangeRate.value / sqftToSqm).toFixed(2)
					: heightRangeRate.value;
			}
		}
	}

	return method?.applicationTargetRate;
}

const equal = (a: number, b: number, eps = 1e-6) => {
	return Math.abs(a - b) <= eps;
}